import { render, staticRenderFns } from "./InstanceWaffle.vue?vue&type=template&id=e3fe2784&scoped=true&"
import script from "./InstanceWaffle.vue?vue&type=script&lang=js&"
export * from "./InstanceWaffle.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./InstanceWaffle.vue?vue&type=style&index=0&id=e3fe2784&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e3fe2784",
  null
  ,true
)

export default component.exports